import { render } from "./PrintView.vue?vue&type=template&id=674b66ec&scoped=true"
import script from "./PrintView.vue?vue&type=script&lang=js"
export * from "./PrintView.vue?vue&type=script&lang=js"

import "./PrintView.vue?vue&type=style&index=0&id=674b66ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674b66ec"]])

export default __exports__